import React, { useState } from 'react'

//styles
import "./CatalogoAdmin.css"
import CardComponent from '../../Components/CardComponent/CardComponent'
import { Button, Tabs, TabsProps } from 'antd';
import ProductsAdmin from '../Products/ProductosAdmin';
import CardsAdmin from '../Products/CardsAdmin';
import { MenuItem } from '../../Models/ModalItem';
import AddCardToInventary from '../../Components/AddCardToInventory/AddCardToInventory';
import ModalMenuItem from '../../Components/ModalMenuItem/ModalMenuItem';
import { Inventary } from '../../Models/Inventary';
import UpdateCardForm from '../../Components/AddCardToInventory/UpdateCardForm';
import Title from 'antd/es/typography/Title';

const CatalogoAdmin = () => {
    const [viewTab, setViewTab] = React.useState<String>("1");
    const [open, setOpen] = useState<boolean>(false);
    const [openUpdate, setOpenUpdate] = useState<boolean>(false);
  const [inventary, setInventary] = React.useState<Inventary>();

  let menuItem:MenuItem =   {
    label: <span>Remover sensor</span>,
    title: "Carrito",
    key: '1',
    icon: <></>,
    component: <AddCardToInventary />,
    type: 'CONTENT',
    items: [],
    size: 'small',
    onConfirm: () => {},

  }

  let menuItem2:MenuItem =   {
    label: <span>Remover sensor</span>,
    title: "Update",
    key: '1',
    icon: <></>,
    component: <UpdateCardForm inventary={inventary} />,
    type: 'CONTENT',
    items: [],
    size: 'small',
    onConfirm: () => {},

  }

  const selectInventary = (inventary:Inventary) => {
    setInventary(inventary);
    setOpenUpdate(true);
  }

const items: TabsProps['items'] = [
  {
    key: '1',
    label: 'Productos',
  },
  {
    key: '3',
    label: 'Cartas',
  },
];

    const onChange = (key: string) => {
    setViewTab(key);
    };


  return (
    <>
    <ModalMenuItem menuItem={menuItem} open={open} setOpen={setOpen} updateSize />
    <ModalMenuItem menuItem={menuItem2} open={openUpdate} setOpen={setOpenUpdate} size='normal' />
    
    
    <div className='CatalogoAdmin-layout'>
        <div className='CatalogoAdmin-Header'>
            <div className='CatalogoAdmin-left'>
                <Title level={3} style={{margin:0}}>
                  Catalogo Administrativo
                </Title>

                <Tabs defaultActiveKey="1" items={items} onChange={onChange} />
            </div>
            <div className='CatalogoAdmin-rigth'>
                <Button type='default' onClick={()=>{setOpen(true)}} >Agregar Carta</Button>

                <div className='CatalogoAdmin-cartButton'>
                    <CardComponent ></CardComponent>
                </div>

            </div>

        </div>
        <div className='CatalogoAdmin-Body'>
        {   viewTab=="1" ? <ProductsAdmin /> :
            <CardsAdmin onClickIventary={selectInventary} />

        }
        </div>
    </div>
    </>

  )
}

export default CatalogoAdmin